import { __awaiter, __generator } from "tslib";
var AbstractAdapter = /** @class */ (function () {
    function AbstractAdapter(config) {
        this.trackerBlacklist = config.trackerBlacklist || [];
        this.eventBlacklist = config.eventBlacklist || [];
        this.requestDecorator = config.requestDecorator || (function (request) { return request; });
    }
    AbstractAdapter.prototype.record = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var eventBlacklist, event, adapter;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        eventBlacklist = this.eventBlacklist;
                        event = request.event;
                        return [4 /*yield*/, this.getName()];
                    case 1:
                        adapter = _a.sent();
                        if (event && eventBlacklist.find(function (pattern) { return event.match(new RegExp(pattern)); }) !== undefined) {
                            return [2 /*return*/, {
                                    isIgnored: true,
                                    isSuccess: false,
                                    isResponseConfirmed: false,
                                    adapter: adapter,
                                    finalRequest: request,
                                }];
                        }
                        return [2 /*return*/, this._record(this.requestDecorator(request), request)];
                }
            });
        });
    };
    return AbstractAdapter;
}());
export default AbstractAdapter;
//# sourceMappingURL=AbstractAdapter.js.map